import React from "react";
import { connect } from "react-redux";
import { Styles } from "../styles";

import { CustomText, Input, InputEmail, Select } from "../../../components";
import { Fonts } from "../../../config";
import { Grid } from "@material-ui/core";
import {
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Search,
} from "@material-ui/icons";
import { FormHolder } from "../../../FormConfig";
import { Validations } from "../../../lib";
import filters from "../../../lib/Filters";
import { GetRoleByName } from "../../../services";

function Filters({ isFetching, roleList, onSubmit, onClear, userInfos }) {
  const [show, setShow] = React.useState(true);
  const [ref, setRef] = React.useState(null);
  return (
    <Styles.Content>
      <Styles.HeaderCard>
        <CustomText fontFamily={Fonts.bold} fontSize={1.75}>
          PESQUISAR CADASTROS
        </CustomText>
        <Styles.Hide onClick={() => setShow(!show)}>
          {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </Styles.Hide>
      </Styles.HeaderCard>
      <Styles.Line></Styles.Line>
      {show && (
        <>
          <FormHolder formRef={setRef} onSubmit={onSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <Input name="fullName" inputLabel="Nome" />
              </Grid>
              <Grid item xs={2}>
                <Input
                  name="cpf"
                  inputLabel="CPF"
                  validation={Validations.isCPF}
                  mask={filters.cpfMask}
                />
              </Grid>
              <Grid item xs={3}>
                <Select
                  name="officeId"
                  inputLabel="Cargo"
                  defaultValue={-1}
                  options={
                    roleList ? [{ label: "Todos", value: -1 }, ...roleList] : []
                  }
                  color={GetRoleByName(userInfos?.role?.name)}
                />
              </Grid>
              <Grid item xs={4}>
                <InputEmail name="email" inputLabel="E-mail" />
              </Grid>
            </Grid>
            <Styles.FormButtons>
              <Styles.FormButtonOutlined
                startIcon={<Delete />}
                fullWidth={false}
                type="clear"
                onClick={() => {
                  ref?.clearAllValues(true);
                  onClear();
                }}
              >
                Limpar
              </Styles.FormButtonOutlined>
              <Styles.FormButton
                startIcon={<Search />}
                fullWidth={false}
                type="submit"
              >
                Pesquisar
              </Styles.FormButton>
            </Styles.FormButtons>
          </FormHolder>
        </>
      )}
    </Styles.Content>
  );
}

function mapStateToProps(redux) {
  const { isFetching } = redux.registerAndQuery;
  return { isFetching };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Filters));
